import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
export class TraitRegistryCssTransform extends TraitRegistryCategory {
    label = 'Transform';
    constructor(parent) {
        super(parent);
        super.init();
    }
    translateX = () => new TraitTypeNumericWithSlider({
        label: 'Verschiebung →',
        default: 0,
        css: ({ at, aspect }) => [
            {
                k: 'transform',
                v: `${at.key}(${calculateFixpoint(at, aspect.aspectMount.mountDimensions.aspectWidthInPixel)}px)`,
                prepend: ' '
            }
        ],
        min: -2000,
        max: 2000,
        roundDecimals: 0,
        aspectsTemplate: { core: ['translateFixpoint'] }
    });
    translateY = () => new TraitTypeNumericWithSlider({
        label: 'Verschiebung ↓',
        default: 0,
        min: -2000,
        max: 2000,
        css: ({ at, aspect }) => [
            {
                k: 'transform',
                v: `${at.key}(${calculateFixpoint(at, aspect.aspectMount.mountDimensions.aspectHeightInPixel)}px)`,
                prepend: ' '
            }
        ],
        roundDecimals: 0,
        aspectsTemplate: { core: ['translateFixpoint'] }
    });
    translateFixpoint = () => new TraitTypeSelectWithPreview({
        label: 'Fixpunkt',
        default: 'start',
        select: [['start'], ['center'], ['end']]
    });
    transformOrigin = () => new TraitTypeSelectWithPreview({
        label: 'Transform Origin',
        select: [['center center'], ['left top'], ['40% 60%']]
    });
    translateZ = () => new TraitTypeNumericWithSlider({
        label: 'Verschiebung ↟',
        css: ({ at }) => [{ k: 'transform', v: `${at.key}(${at.scaledValue}px)`, prepend: ' ' }]
    });
    skewX = () => new TraitTypeNumericWithSlider({
        label: 'Kippen X'
    });
    skewY = () => new TraitTypeNumericWithSlider({
        label: 'Kippen Y'
    });
    perspective = () => new TraitTypeNumericWithSlider({
        label: 'Perspektive',
        min: 0,
        max: 200,
        css: ({ at }) => [{ k: 'transform', v: `${at.key}(${at.trait.value}px)`, append: ' ' }]
    });
    scale = () => new TraitTypeNumericWithSlider({
        label: 'Vergrößerung',
        css: ({ at }) => [{ k: 'transform', v: `${at.key}(${at.trait.value},${at.trait.value})`, append: ' ' }],
        min: -1,
        max: 10,
        step: 0.01,
        default: 1
    });
    rotate = () => new TraitTypeNumericWithSlider(rotateInit(this, '⟳'));
    rotateX = () => new TraitTypeNumericWithSlider(rotateInit(this, 'X'));
    rotateY = () => new TraitTypeNumericWithSlider(rotateInit(this, 'Y'));
    rotateZ = () => new TraitTypeNumericWithSlider(rotateInit(this, 'Z'));
    scaleX = () => new TraitTypeNumericWithSlider(scaleInit(this, 'Z'));
    scaleY = () => new TraitTypeNumericWithSlider(scaleInit(this, 'Z'));
    scaleZ = () => new TraitTypeNumericWithSlider(scaleInit(this, 'Z'));
    transformStyle = () => new TraitTypeSelect({
        label: 'Transform Style',
        default: 'flat',
        init: 'preserve-3d',
        select: [['preserve-3d'], ['flat']]
    });
}
const rotateInit = (parent, L) => ({
    label: `Drehung ${L}`,
    css: ({ at }) => [{ k: 'transform', v: `${at.key}(${at.trait.value}deg)`, append: ' ' }],
    min: -360,
    max: 720
});
const scaleInit = (parent, L) => ({
    label: `Vergrößerung ${L}`,
    min: -1,
    max: 10,
    step: 0.01,
    default: 1,
    css: ({ at }) => [{ k: 'transform', v: `${at.key}(${at.trait.value})`, append: ' ' }]
});
export function calculateFixpoint(at, size) {
    const translateFixpoint = at.valueOf.translateFixpoint;
    if (translateFixpoint === 'center') {
        return at.scaledValue - size / 2;
    }
    if (translateFixpoint === 'end') {
        return at.scaledValue - size;
    }
    return at.scaledValue;
}
